/* global ol */

var routeZoomControlTemplate = require('html/templates/routeZoomControl')();

function RouteZoomControl(map, $compile) {
  this.map = map;
  this.$compile = $compile;
  this.control = this.initControl();
}

RouteZoomControl.prototype.initControl = function() {
  this.map.scope.map.overview = this.overview.bind(this);
  this.map.scope.map.zoomToFitRoute = this.zoomToFitRoute.bind(this);

  return new ol.control.Control({
    element: this.$compile(routeZoomControlTemplate)(this.map.scope)[0]
  });
};

RouteZoomControl.prototype.overview = function() {
  this.map.scope.map.selectRoute(null);
  this.zoomToFitAllRoutes();
};

RouteZoomControl.prototype.zoomToFitRoute = function() {
  var route = this.map.scope.map.route;
  var layers = [];

  if (route) {
    layers.push(this.map.routeLayers[route.id].layer);
    this.map.carLayers && layers.push(this.map.carLayers[route.id].layer);

    this.zoomToFitLayers(layers);
  }
};

RouteZoomControl.prototype.zoomToFitAllRoutes = function() {
  this.zoomToFitLayers(this.map.map.getLayers());
};

RouteZoomControl.prototype.zoomToFitLayers = function(layers) {
  var extent = ol.extent.createEmpty();

  layers.forEach(function(layer) {
    var source = layer.getSource();

    if (source.getSource) source = source.getSource();
    ol.extent.extend(extent, source.getExtent());
  });

  if (ol.extent.isEmpty(extent)) return;

  this.map.view.fit(extent, {
    size: this.map.map.getSize(),
    padding: [11, 11, 11, 11]
  });
};

module.exports = RouteZoomControl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/routeZoomControl.js
 ** module id = 188
 ** module chunks = 1
 **/